import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaymentComponent } from './payment/payment.component';
import {MatStepperModule} from '@angular/material/stepper';
import {MatInputModule} from '@angular/material/input';
import { FormsModule,  ReactiveFormsModule } from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import { HttpClientModule } from '@angular/common/http';
import { SnotifyService, SnotifyModule, ToastDefaults } from 'ng-snotify';
import {MatTabsModule, MatDialogModule, MatDialogRef } from '@angular/material';
import { SubscriptionHistoryComponent } from './subscription-history/subscription-history.component';
import { ChannelListComponent } from './channel-list/channel-list.component';
import { PaymentStatusComponent } from './payment-status/payment-status.component';

const tostDefault= ToastDefaults;
tostDefault.toast.pauseOnHover=false;


@NgModule({
  declarations: [
    AppComponent,
    PaymentComponent,
    SubscriptionHistoryComponent,
    ChannelListComponent,
    PaymentStatusComponent
  ],
  entryComponents: [  
    ChannelListComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatStepperModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    HttpClientModule,
    SnotifyModule,
    MatTabsModule,
    MatDialogModule
  ],
  providers: [
    { provide: "SnotifyToastConfig", useValue: tostDefault },
    SnotifyService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
